import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import ClientContext from "./ClientContext";

const useClientContext = () => useDefinedContext(ClientContext, "ClientContext");

export default useClientContext;
